import { render, staticRenderFns } from "./face.vue?vue&type=template&id=373b6a49&scoped=true"
import script from "./face.vue?vue&type=script&lang=js"
export * from "./face.vue?vue&type=script&lang=js"
import style0 from "./face.vue?vue&type=style&index=0&id=373b6a49&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b6a49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373b6a49')) {
      api.createRecord('373b6a49', component.options)
    } else {
      api.reload('373b6a49', component.options)
    }
    module.hot.accept("./face.vue?vue&type=template&id=373b6a49&scoped=true", function () {
      api.rerender('373b6a49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/participateTestOwn/module/face.vue"
export default component.exports